import {ActionWithProgress} from '../../system/buttons';
import React from 'react';
import PulsoidClient from '../../PulsoidClient';

export const DisconnectTwitchButton = ({refresh}) => (
  <ActionWithProgress
    onClick={async () => {
      await new PulsoidClient().disconnectConnectedAccount('Twitch');
      await refresh();
    }}
  >
    Disconnect
  </ActionWithProgress>
);
